import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
const modelsContext = createContext(null);
export const ModelsContextProvider = ({ children }) => {
    const [filters, setFilters] = useState({
        domain: new Set(),
        modelType: new Set(),
        kit: new Set(),
        device: new Set(),
        application: new Set(),
    });
    return (_jsx(modelsContext.Provider, { value: { filters, setFilters }, children: children }));
};
export const useModelsContext = () => {
    const context = useContext(modelsContext);
    if (!context) {
        throw new Error('useModelsContext must be used inside modelsContextProvider');
    }
    return context;
};
